"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Paper_1 = tslib_1.__importDefault(require("@mui/material/Paper"));
const LinearProgress_1 = tslib_1.__importDefault(require("../LinearProgress"));
const SectionContent_1 = tslib_1.__importDefault(require("./SectionContent"));
const SectionContentError_1 = tslib_1.__importDefault(require("./SectionContentError"));
const SectionHeader_1 = tslib_1.__importDefault(require("./SectionHeader"));
/**
 * This is the main component used to render a section in Argus. It is meant to be used in conjunction with
 * SectionHeader and SectionContent
 *
 * @example Displaying a simple section with a header
 * ```typescript
 *   <Section>
 *      <SectionHeader title="Header title" actions={[<button>Action button</button>]} />
 *      <SectionContent>
 *          <div> You can put and component you want to render here </div>
 *      </SectionContent>
 *   </Section>
 * ```
 *
 * @example You can use a slightly different syntax if you want. Here you only need to import Section from core-react
 * ```typescript
 *    <Section>
 *      <Section.Header title="Header title" actions={[<button>Action button</button>]}/>
 *      <Section.Content>
 *          <div> You can put and component you want to render here </div>
 *      </Section.Content>
 *   </Section>
 * ```
 *
 * * @example You can toggle between Section.Content and Section.ContentError. Here you only need to import Section from core-react
 * ```typescript
 *    <Section>
 *      <Section.Header title="Header title" actions={[<button>Action button</button>]}/>
 *      {isError && <Section.ContentError/>}
 *      {!isError &&
 *        <Section.Content>
 *          <div> You can put and component you want to render here </div>
 *        </Section.Content>
 *      }
 *   </Section>
 * ```
 * @category component
 */
const Section = (props) => {
    const { children, loading = false, LinearProgressProps = {}, ...PaperProps } = props;
    return (react_1.default.createElement(Paper_1.default, { component: "section", ...PaperProps },
        loading && react_1.default.createElement(LinearProgress_1.default, { loading: loading, ...LinearProgressProps }),
        children));
};
Section.Header = SectionHeader_1.default;
Section.Content = SectionContent_1.default;
Section.ContentError = SectionContentError_1.default;
exports.default = Section;
